import { FlexRow } from '@/components/common/Flex';
import { FlexProps } from '@chakra-ui/react';
import { getForecastTimingProps } from '@common/react/goals';
import { Target04 } from '../common/icons';
import { Text } from '../common/Typography';

export interface GoalTimingStatementProps extends FlexProps {
    targetDate: string;
    forecastCompletionDate?: string;
}

const GoalTimingStatement = ({
    targetDate,
    forecastCompletionDate,
    ...props
}: GoalTimingStatementProps) => {
    let timingText: JSX.Element | null;
    if (!forecastCompletionDate) {
        timingText = null;
    } else {
        const { label, color } = getForecastTimingProps(
            targetDate,
            forecastCompletionDate
        );
        timingText = (
            <>
                <Text fontSize="sm" color="textMuted">
                    {`At this rate you'll reach your goal`}
                </Text>
                <Text fontSize="sm" color={color}>
                    {label}
                </Text>
            </>
        );
    }

    return (
        <FlexRow
            alignItems="center"
            gap={1}
            {...props}
            // if text is not defined, hide content but maintain vertical space
            opacity={timingText ? 1 : 0}
        >
            <Target04 mr={2} />
            {timingText}
        </FlexRow>
    );
};

export default GoalTimingStatement;
